import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { fetchEvents } from '../../store/slices/eventSlice';
import { useParams } from 'react-router-dom';
import EventCard from './EventCard';   // 👈 usamos el componente nuevo
import { isEventPast, isEventUpcoming } from "../../utils/date";

const Events = () => {
  const dispatch = useDispatch();
  const { slug } = useParams();
  const { events, loading, error } = useSelector((state) => state.events);

  useEffect(() => {
    dispatch(fetchEvents(slug));
  }, [dispatch, slug]);

  const { upcoming, past } = React.useMemo(() => {
    const u = [];
    const p = [];
    events.forEach(ev => {
      if (isEventPast(ev.date)) {
        p.push(ev);
      } else {
        u.push(ev);
      }
    });
    // Ordenar próximos por fecha ascendente, pasados por fecha descendente
    u.sort((a, b) => new Date(a.date) - new Date(b.date));
    p.sort((a, b) => new Date(b.date) - new Date(a.date));
    return { upcoming: u, past: p };
  }, [events]);

  if (loading) return (
    <div className="min-h-[60vh] flex flex-col items-center justify-center gap-4">
      <div className="w-12 h-12 border-4 border-primary-orange/20 border-t-primary-orange rounded-full animate-spin"></div>
      <p className="text-white/20 font-bold uppercase tracking-widest text-xs">Cargando Eventos...</p>
    </div>
  );

  if (error) return <div className="text-center text-red-500 py-20">Error al cargar eventos: {error}</div>;

  return (
    <div className="container mx-auto px-4 py-10 max-w-7xl">
      {upcoming.length > 0 && (
        <section className="mb-20">
          <div className="flex items-center gap-4 mb-10">
            <div className="h-px flex-1 bg-gradient-to-r from-transparent to-white/10"></div>
            <h2 className="text-2xl font-black text-white tracking-tight uppercase italic">Próximos <span className="text-primary-orange">Eventos</span></h2>
            <div className="h-px flex-1 bg-gradient-to-l from-transparent to-white/10"></div>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
            {upcoming.map((ev) => (
              <EventCard key={ev._id} ev={ev} slug={slug} color="#2563eb" />
            ))}
          </div>
        </section>
      )}

      {past.length > 0 && (
        <section className="opacity-80">
          <div className="flex items-center gap-4 mb-10">
            <div className="h-px flex-1 bg-gradient-to-r from-transparent to-white/5"></div>
            <h2 className="text-lg font-bold text-white/30 tracking-widest uppercase">Eventos Finalizados</h2>
            <div className="h-px flex-1 bg-gradient-to-l from-transparent to-white/5"></div>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
            {past.map((ev) => (
              <EventCard key={ev._id} ev={ev} slug={slug} color="#2563eb" />
            ))}
          </div>
        </section>
      )}

      {events.length === 0 && (
        <div className="text-center py-20 bg-surface/50 rounded-[40px] border border-white/5">
          <p className="text-white/20 font-bold uppercase tracking-[4px]">Todavía no hay eventos disponibles.</p>
        </div>
      )}
    </div>
  );
};

export default Events;


// import React, { useEffect } from 'react';
// import { useSelector, useDispatch } from 'react-redux';
// import { fetchEvents } from '../../store/slices/eventSlice';
// import { useParams, Link } from 'react-router-dom';
// import ShareMenu from './ShareMenu';


// const Events = () => {
//     const dispatch = useDispatch();
//     const { slug } = useParams();
//     const { events, loading, error } = useSelector((state) => state.events);

//     useEffect(() => {
//         dispatch(fetchEvents(slug));
//     }, [dispatch, slug]);

//     if (loading) return <div>Cargando eventos...</div>;
//     if (error)   return <div>Error al cargar eventos: {error}</div>;

//     return (
//         <div className="container mx-auto px-4 py-8">
//             <h1 className="text-3xl font-bold mb-6">Eventos Disponibles</h1>
//             <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
//                 {events.map((event) => (
//                     <div key={event._id}  className="border border-gray-300 bg-gray-50 p-4 rounded shadow-sm hover:shadow-md transition-shadow">
//                         <h2 className="text-xl font-semibold">{event.title}</h2>
//                         <p className="mt-2">{event.description}</p>
//                         <p className="mt-2">Fecha: {new Date(event.date).toLocaleDateString('es-AR', { timeZone: 'UTC' })}</p>
//                         <p className="mt-2">Precio: ${event.price}</p>
//                         <Link
//                            to={`/${slug}/events/${event._id}`}
//                             className="inline-flex items-center gap-2 rounded-lg px-3 py-2 bg-blue-600 text-white text-sm hover:bg-blue-700 transition"
//                         >
//                             Ver Detalles
//                         </Link>

//                         <ShareMenu slug={slug} event={event} />
//                     </div>
//                 ))}
//             </div>
//         </div>
//     );
// };

// export default Events;
